import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

export default class IframelyBlot extends BlockEmbed {
  static blotName = 'iframely';
  static tagName = 'DIV';
  static className = 'iframely';

  static create(data: { value: string }) {
    const node = super.create();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = data.value;

    let content = data.value;
    // if this is an old iframe embed, it will be wrapped in a extra div, this code will merge those divs to a single one
    if (tempDiv.children.length === 1 && tempDiv.firstChild instanceof HTMLDivElement) {
      content = tempDiv.firstChild.innerHTML;
    }

    node.classList.add('embed-responsive');

    if (data.value.includes('secret')) {
      node.classList.add('secret-padding');
    } else {
      node.classList.add('iframely-padding');
    }
    node.innerHTML = content;

    return node;
  }

  static value(node: HTMLElement) {
    return { value: node.innerHTML };
  }

  static formats() {
    return null; // 🚫 No formatting allowed
  }

  format() {
    return; // 🚫 Do nothing (prevents inline edits)
  }
}

Quill.register('formats/iframely', IframelyBlot);
